import Layout from "../components/Layout";
import { Helmet } from "react-helmet-async";

const Learning = () => {
  const sections = [
    {
      title: "RedERP Academy Overview",
      content:
        "Your hub for ERP education. Learn how RedERP helps small and growing businesses succeed.",
    },
    {
      title: "Beginner's Guide to ERP",
      content:
        "Understand what ERP is, how it works, and why it's essential for businesses of all sizes.",
    },
    {
      title: "RedERP Modules Explained",
      content:
        "Explore Sales, Inventory, CRM, Accounting, Manufacturing and more in structured micro-lessons.",
    },
    {
      title: "Interactive Tutorials",
      content:
        "Step-by-step guides and video walk-throughs help you get hands-on with RedERP features.",
    },
    {
      title: "Webinars & Workshops",
      content:
        "Join upcoming live sessions and access past recordings to deepen your ERP skills.",
    },
    {
      title: "Certifications (Coming Soon)",
      content:
        "Earn credentials by completing module-based assessments and demonstrate your ERP expertise.",
    },
  ];

  return (
    <Layout>
      <Helmet>
        <title>Red Academy – Learn ERP the Smart Way</title>
        <meta
          name="description"
          content="Master ERP fundamentals and RedERP modules with Red Academy. Free resources for all user levels."
        />
      </Helmet>

      <section className="py-28 bg-gray-50 px-6 text-center">
        <div className="max-w-3xl mx-auto mb-10">
          <h1 className="text-4xl font-bold text-primary mb-4">Red Academy</h1>
          <p className="text-gray-600 text-lg">
            Master ERP fundamentals and RedERP modules with Red Academy.
            Free resources for all user levels.
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-10 text-left">
          {sections.map((section, i) => (
            <div
              key={i}
              className="bg-white p-6 rounded-xl shadow hover:shadow-md transition-all border border-gray-100"
            >
              <h3 className="text-xl font-bold text-primary mb-2">{section.title}</h3>
              <p className="text-sm text-gray-700">{section.content}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default Learning;
